var _defs, _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    width: 40,
    height: 40,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1Wdsvr44 {\n      fill: #38ff9c;\n      }\n\n      .cls-1Wdsvr44, .cls-2Wdsvr44, .cls-3Wdsvr44, .cls-4Wdsvr44, .cls-5Wdsvr44 {\n      stroke-width: 0px;\n      }\n\n      .cls-2Wdsvr44 {\n      fill: #38ff9c;\n      }\n\n      .cls-3Wdsvr44 {\n      fill: #38ff9c;\n      }\n\n      .cls-4Wdsvr44 {\n      fill: #38ff9c;\n      }\n\n      .cls-5Wdsvr44 {\n      fill: #38ff9c;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etherlink-linear-gradient",
    x1: 115.55,
    y1: 540,
    x2: 1300.54,
    y2: 540,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38ff9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38ff9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etherlink-linear-gradient-2",
    x1: 306.58,
    y1: 472.7,
    x2: 752.37,
    y2: 472.7,
    xlinkHref: "#etherlink-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etherlink-linear-gradient-3",
    x1: 447.31,
    y1: 607.58,
    x2: 890.68,
    y2: 607.58,
    xlinkHref: "#etherlink-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etherlink-linear-gradient-4",
    x1: 306.79,
    y1: 671.18,
    x2: 643.02,
    y2: 671.18,
    gradientTransform: "translate(593.73 -91.03) rotate(45)",
    xlinkHref: "#etherlink-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etherlink-linear-gradient-5",
    x1: 571.14,
    y1: 407.43,
    x2: 881.36,
    y2: 407.43,
    gradientTransform: "translate(484.65 -355.2) rotate(45)",
    xlinkHref: "#etherlink-linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1Wdsvr44",
    d: "M540,115.55c-234.42,0-424.45,190.03-424.45,424.45s190.03,424.45,424.45,424.45,424.45-190.03,424.45-424.45S774.42,115.55,540,115.55ZM540,889.32c-192.92,0-349.32-156.39-349.32-349.32s156.39-349.32,349.32-349.32,349.32,156.39,349.32,349.32-156.39,349.32-349.32,349.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3Wdsvr44",
    d: "M537.66,306.59c-128.43,1.26-232.51,107.66-231.07,236.09.37,32.84,7.52,64.05,20.13,92.3,1.89,4.23,7.48,5.17,10.7,1.85l51.46-53.11c3.36-3.46,4.74-8.36,3.76-13.09-2.04-9.89-3.11-20.13-3.11-30.63,0-83.12,67.37-150.49,150.46-150.49,8.5,0,16.83.7,24.95,2.06,5.43.91,10.97-.81,14.81-4.77l51.18-52.8c3-3.09,1.95-8.26-2.03-9.9-28.08-11.57-58.91-17.84-91.25-17.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4Wdsvr44",
    d: "M542.31,773.7c128.43-1.26,232.51-107.66,231.07-236.09-.37-32.84-7.52-64.05-20.13-92.3-1.89-4.23-7.48-5.17-10.7-1.85l-51.46,53.11c-3.36,3.46-4.74,8.36-3.76,13.09,2.04,9.89,3.11,20.13,3.11,30.63,0,83.12-67.37,150.49-150.46,150.49-8.5,0-16.83-.7-24.95-2.06-5.43-.91-10.97.81-14.81,4.77l-51.18,52.8c-3,3.09-1.95,8.26,2.03,9.9,28.08,11.57,58.91,17.84,91.25,17.52Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2Wdsvr44",
    x: 286.49,
    y: 620.24,
    width: 240.51,
    height: 101.87,
    rx: 50.94,
    ry: 50.94,
    transform: "translate(-355.46 484.2) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5Wdsvr44",
    x: 550.84,
    y: 356.49,
    width: 240.51,
    height: 101.87,
    rx: 50.94,
    ry: 50.94,
    transform: "translate(-91.54 593.87) rotate(-45)"
  })));
};
export default SvgLogoNoText;